module.exports = __webpack_public_path__ + "img/success.832f3224.svg";